import { ISelectionChangeEvent } from './types';

export const isSelectionChangeEvent = (event: unknown): event is ISelectionChangeEvent => {
    return !!event && typeof event === 'object' && 'name' in event && event.name === 'selectionchange';
};
